/*
 * @Author: changfuguo changfuguo@didichuxing.com
 * @Date: 2022-06-26 23:09:15
 * @LastEditors: changfuguo changfuguo@didichuxing.com
 * @LastEditTime: 2022-06-29 15:50:03
 * @FilePath: /es-package/packages/es-tanker-recognizer/lib/PayChannel/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
class PayChannelRecognizer {
  constructor(options = {}) {
    this.options = Object.assign({}, options);

    const { userAgent, ua } = this.options;
    this.toBeCheckedUA = userAgent || ua; // 待检测的useragent
    this.toBeCheckedUAKey = options.toBeCheckedUAKey || 'app';
    this.assistants = {};
    this.payChannels = this.payChannels || ['wx', 'zfb']; //目前支持的支付方式

    // 默认有公司id的校验
    this.addAssistant('company_id', PayChannelRecognizer.ass_company_id)
  }

  loadRule (rootRule = {}) {
    this.rootRule = rootRule;
  }
  addAssistant (key, fn) {
    this.assistants[key] = fn;
  }
  // 检查rootRule是否有配置
  checkRule () {
    return this.rootRule ? this.payChannels.reduce((initila, key) => this.rootRule[key] ? (initila + 1) : initila, 0) > 0 : false;
  }
  checkApp (tankerRules = []) {
    const rules = tankerRules, ml = rules.length;
    if (rules == 0) return false;
    for (let i = 0; i < ml; i++) {
      if (!this.checkAppRule(rules[i])) {
        return false;
      }
    }
    return true
  }
  checkAppRule (rule) {
    let dir = '+', v = '';
    if (Object.prototype.toString.call(rule) === '[object String]') {
      v = rule
    } else if (Array.isArray(rule)) {
      if (rule.length == 0) return true;
      if (rule.length == 2) {
        dir = rule[0];
        v = rule[1];
      } else if (rule.length == 1) {
        v = rule[0]
      }
    }

    const reg = new RegExp(v.toLowerCase(), 'ig');
    const sug = dir == '+' ? true : false;
    const tested = reg.test(this.toBeCheckedUA.toLowerCase());
    return v == '' ? false : sug ? tested : !tested;
  }
  checkAssistants (rest = {}) {
    const toBeCheckedArr = Object.keys(this.assistants);
    for (let i = 0; i < toBeCheckedArr.length; i++) {
      const fnKey = toBeCheckedArr[i];
      if (!rest[fnKey] || typeof this.assistants[fnKey] !== 'function') return true;

      return this.assistants[fnKey](this[fnKey], rest[fnKey]);
    }
    return true;
  }
  matchChannel (payChannel, payChannelValue) {
    if (!payChannelValue) return false;
    const len = payChannelValue.length;

    for (let i = 0; i < len; i++) {
      const tanker = payChannelValue[i];
      const { app, ...rest } = tanker;
      if (this.checkApp(app) && this.checkAssistants(rest)) {
        return payChannel;
      }
    }
    return false;
  }
  match () {
    const rootRule = this.rootRule;
    const payChannels = this.payChannels;
    const matches = [];

    payChannels.map((payChannel) => {
      const matched = this.matchChannel(payChannel, rootRule[payChannel]);
      if (matched) {
        matches.push(matched);
      }
    })
    return matches;
  }
}
/**
 * @description 默认帮主函数增加公司id的校验
 * 
 * **/
PayChannelRecognizer.ass_company_id = (value = '', list = []) => {
  if (!value || !list) {
    return true;
  }
  if (Object.prototype.toString.call(list) === '[object String]') {
    return value === list;
  } else if (Array.isArray(list) && list.length > 0) {
    return list.indexOf(value) > -1;
  }
  return true;
}
export default PayChannelRecognizer